import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { Scope, UserService } from 'bookraw/shared/services/user.service';
import { AvailableActions } from 'bookraw/shared/models/permission.model';

@Directive({ selector: '[requirePermission]' })
export class RequirePermissionDirective implements OnInit {
  @Input() requirePermission: AvailableActions;
  @Input() menuParams?: string | string[];
  @Input() elementParams?: string | string[];
  @Input() disableMedia?: string | string[];
  @Input() onlyAdmin?: boolean;
  @Input() except?: Scope[];

  constructor(private elementRef: ElementRef, private userService: UserService) {
  }

  ngOnInit(): void {
    if ( false === this.userService.can(
        this.requirePermission, 
        this.menuParams, 
        this.onlyAdmin, 
        this.except, 
        this.disableMedia, 
        this.elementParams
      ) ) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
}
